// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"11":"c3ae477d","154":"232d1efd","661":"78450d65","683":"d3b67dc3","952":"bae18be7"}[chunkId] + ".css";
};